import { createSlice, current } from "@reduxjs/toolkit";
import { getCurrentUtcTime } from "../helper";

// required:  define initial state for cart module
export const storeInitialState = {
    storeDetails: {},
    isLoading: false

}

// required:  create slice for cart module with required reducers (actions)
export const storeSlice = createSlice({
    name: "store",
    initialState: storeInitialState,
    reducers: {
        storeDetailsPending: (state,action)=>{
            state.isLoading = true;
        },
        addStoreDetails:  (state, action) => {
            state.isLoading = true;
            state.storeDetails = false;

            const {storeDetails} = action.payload;
            try{
                if(storeDetails){
                    if (storeDetails.is_opened == 0) {
                    let current_time = getCurrentUtcTime();
                    let store_on_time = storeDetails.ontime;
                    let diff_time_hh, diff_time_mm;
                    if (parseInt(store_on_time.split(":")[0], 10) >= parseInt(current_time.split(':')[0], 10)) {
                        diff_time_hh = Math.abs(parseInt(current_time.split(':')[0], 10) - parseInt(store_on_time.split(":")[0], 10));
                    } else {
                        diff_time_hh = 24 - Math.abs(parseInt(current_time.split(':')[0], 10) - parseInt(store_on_time.split(":")[0], 10));
                    }
                    
                    diff_time_mm = Math.abs(parseInt(current_time.split(':')[1], 10) - parseInt(store_on_time.split(":")[1], 10));
                    
                    state.err = {
                        message:("We are out of delivery hours right now. Deliveries will begin in about " + diff_time_hh + " hours " + diff_time_mm + " mins. Thanks")
                    }
                    state.isLoading = false ;
    
                    }
                    else if (storeDetails.status === 'paused') {
                        state.err = {
                            message:("We are currently facing issues in delivering at this location. Sorry for the inconvenience")
                        }
                        state.isLoading = false ;
    
                    }
                    else if (storeDetails.status === 'closed') {
                        state.err = {
                            message:"We are out of operational hours right now. Thanks"
                        }
                        state.isLoading = false ;
    
                    }
                    else{ 
                        state.storeDetails = storeDetails;
                        state.isLoading = false ;
                        state.err = null
                    }
                }else if (action.payload.err){

                    if(action.payload.err & action.payload.err.message.includes("No store found")){
                        state.err = {
                            message: "No Store Found for this store Id"
                        }

                    }else{
                        state.err = action.payload.err
                    }
                    state.isLoading = false ;
                }
            }catch(err){
                state.err = {
                    message: err.message
                }
                state.isLoading = false ;
            }

            
        },
        storeDetailsErr: (state, action) => {
            state.err = action.payload;
        },
    },
});

// required: export all defined reducer functions as actions
export const {
    addStoreDetails,
    storeDetailsPending
} = storeSlice.actions;

// required: export complete reducer
export default storeSlice.reducer;